import * as Yup from "yup";

export function getAuthInitialValues(obj) {
  return {
    email: obj?.email || "",
    password: obj?.password || "",
    confirmPassword: obj?.confirmPassword || "",

    // Basic Info
    name: obj?.name || "",
    phoneNumber: obj?.phoneNumber || "",
    businessName: obj?.businessName || "",

    // Address Details
    address: obj?.address || "",
    city: obj?.city || "",
    state: obj?.state || "",
    zip: obj?.zip || "",
    country: obj?.country || "",

    // Business Information
    taxId: obj?.taxId || "",
    dnbNum: obj?.dnbNum || "",
    businessUrl: obj?.businessUrl || "",
    businessDesc: obj?.businessDesc || "",

    // Bill To
    customerAddressCheck: obj?.customerAddressCheck || "",
    billName: obj?.billName || "",
    billPhoneNumber: obj?.billPhoneNumber || "",
    billContactName: obj?.billContactName || "",
    billEmail: obj?.billEmail || "",

    // Address Details
    billAddress: obj?.billAddress || "",
    billCity: obj?.billCity || "",
    billState: obj?.billState || "",
    billZip: obj?.billZip || "",
    billingContactEmail: obj?.billingContactEmail || "",
    otherContactEmail: obj?.otherContactEmail || "",

    termsAndCondition: obj?.termsAndCondition || "",
  };
}
export function getValidateSchema(flag, locale) {
  let schemaAttributes;
  if (flag) {
    schemaAttributes = {
      email: Yup.string()
        .trim()
        .email(locale("emailInvalid"))
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, locale("emailInvalid")),
      password: Yup.string()
        .label("Password")
        .required(locale("passwordRequired"))
        .matches(/[a-z]+/, locale("passwordLowerCase"))
        .matches(/[A-Z]+/, locale("passwordUpperCase"))
        .matches(/[!+@#$%^&*()\-_"=+{}; :,<.>]/, locale("passwordSymbol"))
        .matches(/\d+/, locale("passwordNumeral"))
        .min(8, locale("passwordMinLength"))
        .max(20, locale("passwordMaxLength")),
      confirmPassword: Yup.string()
        .trim()
        .required(locale("confirmPasswordRequired"))
        .oneOf([Yup.ref("password"), null], locale("passwordMismatch")),

      name: Yup.string().trim().required(locale("nameRequired")),
      phoneNumber: Yup.string()
        .trim()
        .required(locale("phoneRequired"))
        .matches(
          /^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/,
          locale("phoneInvalid")
        ),
      businessName: Yup.string()
        .trim()
        .required(locale("businessNameRequired")),

      address: Yup.string().trim().required(locale("addressRequired")),
      city: Yup.string().trim().required(locale("cityRequired")),
      state: Yup.string().trim().required(locale("stateRequired")),
      zip: Yup.string().trim(),

      taxId: Yup.string().trim().when('country', {
        is: (val) => val === 'CANADA',
        then: (schema) => schema
          .min(4, locale('registration_number_min_digits')),
        otherwise: (schema) => schema
          .min(9, locale('taxIdMin'))
      }),

      businessUrl: Yup.string()
        .trim()
        .matches(
          /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
          "Enter correct url"
        ),
      billingContactEmail: Yup.string()
        .required(locale("emailRequired"))
        .email(locale("emailInvalid"))
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, locale("emailInvalid")),
      otherContactEmail: Yup.string().email(locale("emailInvalid")),
      termsAndCondition: Yup.boolean().oneOf([true], ""),
    };
  } else {
    schemaAttributes = {
      email: Yup.string()
        .email(locale("emailInvalid"))
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, locale("emailInvalid")),
      // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int){1}$/,locale('emailInvalid')),
      // .email(locale('emailInvalid')).matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/),
      password: Yup.string()
        .label("Password")
        .required(locale("passwordRequired"))
        .matches(/[a-z]+/, locale("passwordLowerCase"))
        .matches(/[A-Z]+/, locale("passwordUpperCase"))
        .matches(/[!+@#$%^&*()\-_"=+{}; :,<.>]/, locale("passwordSymbol"))
        .matches(/\d+/, locale("passwordNumeral"))
        .min(8, locale("passwordMinLength"))
        .max(20, locale("passwordMaxLength")),
      confirmPassword: Yup.string()
        .trim()
        .required(locale("confirmPasswordRequired"))
        .oneOf([Yup.ref("password"), null], locale("passwordMismatch")),

      name: Yup.string().trim().required(locale("nameRequired")),
      phoneNumber: Yup.string()
        .trim()
        .required(locale("phoneRequired"))
        .matches(
          /^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/,
          locale("phoneInvalid")
        ),
      businessName: Yup.string()
        .trim()
        .required(locale("businessNameRequired")),

      address: Yup.string().trim().required(locale("addressRequired")),
      city: Yup.string().trim().required(locale("cityRequired")),
      state: Yup.string().trim().required(locale("stateRequired")),
      zip: Yup.string().trim(),

      taxId: Yup.string().trim().when('country', {
        is: (val) => val === 'CANADA',
        then: (schema) => schema
          .min(4, locale('registration_number_min_digits')),
        otherwise: (schema) => schema
          .min(9, locale('taxIdMin'))
      }),

      dnbNum: Yup.string()
        .trim()
        .min(9, locale("dnsDunsMinLength"))
        .matches(
          /^(?!(?:\D*0)+\D*$)\(?([0-9]{2})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/,
          locale("dunsInvalid")
        ),
      businessUrl: Yup.string()
        .trim()
        .matches(
          /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
          locale("enterCorrectUrl")
        ),

      billName: Yup.string().trim().required(locale("nameRequired")),
      billPhoneNumber: Yup.string()
        .trim()
        .required(locale("phoneRequired"))
        .matches(
          /^(?!(?:\D*0)+\D*$)\(?([0-9]{3})\)?[-. ]?[0-9]{3}[-. ]?[0-9]{4}$/,
          locale("phoneInvalid")
        ),
      billContactName: Yup.string()
        .trim()
        .required(locale("businessNameRequired")),
      billEmail: Yup.string().email(locale("emailInvalid")),

      billAddress: Yup.string().trim().required(locale("addressRequired")),
      billCity: Yup.string().trim().required(locale("cityRequired")),
      billState: Yup.string().trim().required(locale("stateRequired")),
      billZip: Yup.string().trim(),
      billingContactEmail: Yup.string()
        .required(locale("emailRequired"))
        .email(locale("emailInvalid"))
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, locale("emailInvalid")),
      otherContactEmail: Yup.string().email(locale("emailInvalid")),
      termsAndCondition: Yup.boolean().oneOf([true], ""),
    };
  }
  return Yup.object().shape(schemaAttributes);
}
